import React, { useState, useEffect, useRef } from "react";
import "../Styles/UMGridCentreLayout.css"; // CSS for styling
import { FaPaperclip, FaSmile } from "react-icons/fa"; // Icons for attachment & smiley

const mockMessages = [
  {
    id: 1,
    sender: "Alice",
    message: "Hey! How are you?",
    timestamp: "2025-03-08T10:30:00",
  },
  {
    id: 2,
    sender: "User",
    message: "I'm good! Just finished my work. What about you?",
    timestamp: "2025-03-08T10:35:00",
  },
  {
    id: 3,
    sender: "Alice",
    message: "That's great! I'm planning a trip this weekend.",
    timestamp: "2025-03-09T14:00:00",
  },
  {
    id: 4,
    sender: "User",
    message: "Nice! Where are you going?",
    timestamp: "2025-03-09T14:10:00",
  },
];

// Function to group messages by date
const groupMessagesByDate = (messages) => {
  return messages.reduce((acc, msg) => {
    const date = new Date(msg.timestamp).toDateString();
    if (!acc[date]) {
      acc[date] = [];
    }
    acc[date].push(msg);
    return acc;
  }, {});
};

const UMGridCentreLayout = () => {
  const [messages, setMessages] = useState(mockMessages);
  const [newMessage, setNewMessage] = useState("");
  const messagesEndRef = useRef(null); // Reference to scroll to bottom

  // Scroll to the bottom when messages change
  useEffect(() => {
    messagesEndRef.current?.scrollIntoView({ behavior: "smooth" });
  }, [messages]);

  // Function to send a message
  const sendMessage = () => {
    if (newMessage.trim() === "") return;

    const newMsg = {
      id: messages.length + 1,
      sender: "User",
      message: newMessage,
      timestamp: new Date().toISOString(),
    };

    setMessages([...messages, newMsg]);
    setNewMessage("");
  };

  const groupedMessages = groupMessagesByDate(messages);

  return (
    <div style={{width: 1000, display: "flex", flexDirection: "column"}}>
      {/* Message Display Container */}
      <div className="uac-message-display">
        {Object.keys(groupedMessages).map((date) => (
          <div key={date}>
            <div className="uac-date-separator">{date}</div>
            {groupedMessages[date].map((msg) => (
              <div
                key={msg.id}
                className={`message-bubble ${msg.sender === "User" ? "sent" : "received"}`}
                style={{color: "black"}}
              >
                <div className="message-text" style={{color: "black"}}>{msg.message}</div>
                <div className="message-time" style={{color: "black"}}>
                  {new Date(msg.timestamp).toLocaleTimeString([], { hour: "2-digit", minute: "2-digit" })}
                </div>
              </div>
            ))}
          </div>
        ))}
        <div ref={messagesEndRef} />
      </div>

      {/* Message Input Box */}
      <div className="uac-message-input" style={{width: 670, height: 130 }}>
        <button className="icon-button" style={{width: 40}}>
          <FaPaperclip size={20} />
        </button>
        <input
          style={{width: 900, color: "black"}}
          type="text"
          placeholder="Type your message..."
          value={newMessage}
          onChange={(e) => setNewMessage(e.target.value)}
        />
        <button className="icon-button" style={{width: 50}}>  
          <FaSmile size={20} />
        </button>
        <button className="send-button" onClick={sendMessage} style={{width: 70}}>Send</button>
      </div>
    </div>
  );
};

export default UMGridCentreLayout;
